<template>
  <v-container fluid class="pt-3">
    <DriverAdminTable
      :shop="shop"
      :gp="true"
      :showStat="true"
    ></DriverAdminTable>
  </v-container>
</template>
<script>
import DriverAdminTable from "@/components/table/DriverAdminTable";

export default {
  components: {
    DriverAdminTable,
  },
  data() {
    return {
      shop: null,
    };
  },
  created() {},
};
</script>
